import { cn } from '@crm/ui';

/**
 * A marca do produto: cabeca de robo com antena e olhos em barra - bot, sem
 * sorriso de brinquedo. Em SVG e nao em imagem porque assim acompanha o tema
 * (as cores saem do proprio CSS) e nao serrilha em tela grande.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 208 48"
      className={cn('h-9 w-auto', className)}
      role="img"
      aria-label="SellerBot"
    >
      <title>SellerBot</title>

      <g className="fill-primary">
        <circle cx="24" cy="5" r="3" />
        <rect x="22.5" y="7" width="3" height="5" rx="1.5" />
        <rect x="8" y="12" width="32" height="26" rx="7" />
        <rect x="2" y="19" width="4" height="11" rx="2" />
        <rect x="42" y="19" width="4" height="11" rx="2" />
      </g>

      <g className="fill-background">
        <rect x="14" y="21" width="7" height="7" rx="2.5" />
        <rect x="27" y="21" width="7" height="7" rx="2.5" />
        <rect x="18" y="32" width="12" height="2.5" rx="1.25" opacity="0.55" />
      </g>

      <text
        x="56"
        y="33"
        className="fill-foreground font-mono text-[25px] font-semibold tracking-tighter"
      >
        Seller
        <tspan className="fill-primary">Bot</tspan>
      </text>
    </svg>
  );
}
